import blog12Main from "@/assets/images/blogs/12/main.jpg";
import blog12_1 from "@/assets/images/blogs/12/Maslobojev.jpeg";
import blog12_2 from "@/assets/images/blogs/12/advertorial-inflammation.png";
import blog12_3 from "@/assets/images/blogs/12/Sergej-Maslobojev-glory.jpg";
import blog12_4 from "@/assets/images/blogs/12/mantas-strolia.jpg";
import blog12_5 from "@/assets/images/blogs/12/mantas-strolia-1.jpeg";
import blog12_6 from "@/assets/images/blogs/12/biologinis-amzius.png";
import blog12_7 from "@/assets/images/health-protocol-download.png";
import { ArrowRight } from "lucide-react";
import { BLOG_TAGS } from "../BlogTags";
import ArrowUpRight from "@/assets/icons/arrow-up-right";
import ROUTES from "@/data/Routes";
import BlogContent, { BlogContentWithSlug } from "../BlogContent";
import { addSlug } from "@/utils/addSlug";
import { ReactNode } from "react";
import { ActionLink } from "@/components/UI/Buttons";

const NumberedArticle = ({
  number,
  children,
}: {
  number: string;
  children: ReactNode;
}) => (
  <div className="bg-legacy-grey-100 flex w-full items-center gap-[14px] rounded-[14px] px-[30px] py-[20px]">
    <p className="mb-0 w-[22px] shrink-0 font-medium text-[#b7b7b7] md:text-lg">
      {number}
    </p>
    <div className="text-text mb-0 shrink-0 font-medium whitespace-pre-wrap md:text-lg">
      {children}
    </div>
  </div>
);

const CheckmarkItem = ({ children }: { children: ReactNode }) => (
  <div className="flex w-full items-center gap-[14px] rounded-[14px]">
    <div className="flex h-[20px] w-[20px] shrink-0 items-center justify-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28ZM21.832 12.3965L14.2142 20.0142L10.1638 15.9639L11.578 14.5497L14.2142 17.1858L20.4178 10.9822L21.832 12.3965Z"
          fill="var(--color-body)"
        />
      </svg>
    </div>
    <div className="text-text mb-0 whitespace-pre-wrap md:text-lg">
      {children}
    </div>
  </div>
);

//TEST FORM ID:oetrq8Sv
const ToTestBtn = () => (
  <a
    href={`https://telomera.typeform.com/to/${
      import.meta.env.VITE_TYPEFORM_ADVERTORIAL
    }`}
    target="_blank"
    rel="noopener noreferrer"
    style={{ position: "relative", paddingRight: "48px" }}
    className="group bg-sand flex w-min cursor-pointer items-center gap-[10px] rounded-[40px] p-2 pr-[40px] hover:enabled:brightness-95 md:gap-[14px]"
  >
    <span
      style={{ lineHeight: "40px" }}
      className="text-primary flex-nowrap px-4 font-medium whitespace-nowrap md:text-lg"
    >
      Pradėti testą
    </span>
    <div
      style={{ position: "absolute", right: "8px", transition: "all 0.3s" }}
      className="bg-primary flex h-[40px] w-[40px] items-center justify-center rounded-full group-hover:w-[calc(100%-16px)]"
    >
      <ArrowUpRight width={24} height={24} color={"var(--color-sand)"} />
    </div>
  </a>
);

const ADVERTORIAL_TO_TEST_WITHOUT_SLUG: BlogContent = {
  id: 12,
  advertorialData: {
    header: "Atsakyk į 5min testą ir gauk asmeninį veiksmų planą",
    button: <ToTestBtn />,
  },
  label:
    "Kodėl du žmonės treniruojasi vienodai, bet genetika nulemia skirtingus rezultatus?",
  description:
    "Elitiniai atletai atrodo tarsi sukurti pergalei: galingi, greiti, ištvermingi. Tačiau už jų sėkmės slypi ne tik treniruotės — bet ir unikalus genetinis kodas",
  descriptionInner:
    "Elitiniai atletai atrodo tarsi sukurti pergalei: galingi, greiti, ištvermingi. Tačiau už jų sėkmės slypi ne tik treniruotės — bet ir unikalus genetinis kodas",
  img_src: blog12Main,
  alt: "",
  tags: [
    BLOG_TAGS.SPORTS,
    BLOG_TAGS.GENETICS,
    BLOG_TAGS.EPIGENETICS,
    BLOG_TAGS.GENOME,
  ].map((x) => x.label),
  date: "Feb 19, 2026",
  innerData: [
    {
      id: 1,
      label: "Ką rodo žymių Lietuvos sportininkų DNR tyrimas?",
      description: [
        "Elitiniai atletai atrodo tarsi sukurti pergalei: galingi, greiti, ištvermingi. Tačiau už jų sėkmės slypi ne tik treniruotės — bet ir unikalus genetinis kodas.",
        "„Telomera“ išanalizavo olimpiečio Manto Strolia ir pasaulio kikbokso čempiono Sergejaus Maslobojevo DNR bei epigenetiką. Rezultatai atskleidė, kodėl jų kūnai sugeba pasiekti tokias aukštumas — ir kokias rizikas jie turi įveikti pakeliui.",
        "Šiame straipsnyje sužinosi, kaip genetika ir biologinis amžius formuoja sportinius rezultatus, ir kaip tie patys principai gali padėti tau treniruotis išmintingiau, išvengti traumų bei pasiekti geriausią savo formą.",
      ],
    },
    {
      id: 2,
      label: "Genetikos pagrindai sporte - DNR ir epigentika",
      description: [
        <div className="text-text mt-8 mb-4 font-medium md:mt-2 md:text-xl">
          <b>DNR</b> yra tavo įgimtas genetinis kodas — jis atskleidžia, kam
          tavo kūnas yra natūraliai linkęs, pavyzdžiui:
        </div>,
        <NumberedArticle number="01">
          Raumenų tipas (greito vs lėto susitraukimo skaidulos)
        </NumberedArticle>,
        <NumberedArticle number="02">Atsistatymo greitis</NumberedArticle>,
        <NumberedArticle number="03">Traumų rizika</NumberedArticle>,
        <NumberedArticle number="04">
          VO₂ max (deguonies pasisavinimo) potencialas
        </NumberedArticle>,
        <NumberedArticle number="05">
          Polinkis į uždegiminius procesus
        </NumberedArticle>,
        <div className="text-text mt-8 mb-4 font-medium md:mt-12 md:text-xl">
          <b>Epigenetika</b> rodo, kurie šiuo metu tavo genai yra „įjungti“ ar
          „išjungti“ — tai priklauso nuo tavo gyvenimo būdo. Ji apima:
        </div>,
        <NumberedArticle number="01">Biologinį amžių</NumberedArticle>,
        <NumberedArticle number="02">Senėjimo tempą</NumberedArticle>,
        <NumberedArticle number="03">Uždegimo lygį</NumberedArticle>,
        <NumberedArticle number="04">Oksidacinį stresą</NumberedArticle>,
        <NumberedArticle number="05">Organų sistemų apkrovą</NumberedArticle>,
        <p className="text-text mt-8 md:text-lg">
          Pažiūrėkime, kaip šie įrankiai padėjo dviem elitiniams sportininkams
          priimti geresnius sprendimus.
        </p>,
      ],
    },
    {
      id: 3,
      label: "Kaip S. Maslobojevo DNR padeda jam siekti pergalių kikbokse?",
      description: [
        <b>Ir kaip tavo genetika gali tapti treniruočių pranašumu</b>,
        <img src={blog12_1}></img>,
        <b>1. Sprogstamoji jėga: greitųjų raumenų skaidulų dominavimas</b>,
        "Kikboksas – tai greiti sprogimai: staigūs smūgiai, žaibiškas kojų darbas, galingi spyriai. Visa tai remiasi greitomis raumenų skaidulomis, kurios susitraukia itin greitai ir per trumpą laiką sukuria maksimalią jėgą.",
        "Sergejaus genetika palanki būtent šių greitųjų skaidulų vystymuisi:",
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>Reakcijos greitis</CheckmarkItem>
          <CheckmarkItem>Sprogstama energija</CheckmarkItem>
          <CheckmarkItem>Nokautuojanti jėga</CheckmarkItem>
        </div>,
        "Ar kada susimąstei, kodėl vieni žmonės lengvai sprintuoja, turi sprogstamą energija ar kelia sunkumus, o kiti labiau spindi ištvermės sportuose?",
        "Tai ne vien treniruotės — tai tavo genetika.",
        "Jei treniruojiesi jėgai, o tavo kūnas natūraliai labiau pritaikytas ištvermei (ar atvirkščiai), gali:",
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>Švaistyti pastangas</CheckmarkItem>
          <CheckmarkItem>Greičiau perdegti</CheckmarkItem>
          <CheckmarkItem>Nepasiekti laukiamų rezultatų</CheckmarkItem>
        </div>,
        "Raumenų tipo pažinimas gali kardinaliai pakeisti tavo treniruočių strategiją — leisdamas tau auginti kūną, kuris dera su tavo biologija.",
        <img src={blog12_2}></img>,
        <b>2. Atsistatymas ir uždegimas: intensyvumo kaina</b>,
        "Kuo intensyviau treniruojiesi, tuo daugiau žalos patiria tavo raumenys. Kūnui reikia greitai suvaldyti uždegimą ir atkurti pažeistus audinius — ypač kontaktiniuose ir aukšto krūvio sportuose.",
        "Sergejus turi genetinių variantų, susijusių su padidėjusiu uždegiminiu atsaku, pavyzdžiui, padidėjusiu IL-6 ir TNF-alfa aktyvumu.",
        "Tai reiškia:",
        " •	Jo organizmas po treniruočių natūraliai gamina daugiau uždegiminių žymenų",
        " •	Atsistatymo procesas gali būti lėtesnis",
        " •	Ilgainiui jis gali būti labiau linkęs į „nusidėvėjimo“ tipo traumas",
        "Raumenų skausmas po treniruotės ar nuovargis po poilsio dienų - nebūtinai valios klausimas. Tai gali būti nulemta tavo genetikos:",
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Kaip efektyviai tavo kūnas pašalina uždegimą
          </CheckmarkItem>
          <CheckmarkItem>
            Kaip greitai jis atkuria raumeninį audinį
          </CheckmarkItem>
          <CheckmarkItem>
            Kiek dažnai tau iš tikrųjų reikia poilsio ar aktyvaus atsistatymo
          </CheckmarkItem>
        </div>,
        "Kai tai žinai — gali nebespėlioti ir pradėti treniruotis išvien su savo kūnu, o ne prieš jį.",
        <img src={blog12_3}></img>,
        <b>3. Psichologinis atsparumas: neurocheminis pranašumas</b>,
        "Kovos menai – tai ne vien fizinis pasirengimas. Jie reikalauja intensyvios koncentracijos, emocijų kontrolės ir gebėjimo išlikti ramiam.",
        "Sergejus turi genetinių variantų, susijusių su dopamino ir serotonino reguliacija, kurie prisideda prie:",
        <div className="mt-2 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>Aukšto atsparumo stresui</CheckmarkItem>
          <CheckmarkItem>Stabilios emocinės būklės įtampos metu</CheckmarkItem>
          <CheckmarkItem>
            Geresnės koncentracijos ir motyvacijos varžybose
          </CheckmarkItem>
        </div>,
        "Ar tau sunku susikaupti ar išlikti motyvuotam? Ar per stresines situacijas subyra tavo dėmesys, kai kiti išlieka ramūs? Šie skirtumai ne visada yra būdo savybės — dažnai tai biologija.",
        "Tavo DNR gali paaiškinti:",
        " •	Kodėl stresas tave paveikia stipriau",
        " •	Kodėl kai kuriomis dienomis nepavyksta „įeiti į zoną“",
        " •	Ar tavo smegenims labiau tinka rutina, stimuliacija ar ramybė",
        "Kai supranti savo neurochemiją, gali susikurti psichologinį planą, kuris iš tiesų veikia pagal tavo smegenų tipą — nesvarbu, ar tai sportas, verslas, ar kasdienybė.",
      ],
    },
    {
      id: 4,
      label: "Mantas Strolia – olimpinis ištvermės kodas",
      description: [
        <b>
          Kaip jo genai ir biologija padeda atskleisti, kur slypi tavo sportinis
          potencialas
        </b>,
        <img src={blog12_4} />,
        <b>1. Ištvermės variklis: gimęs aerobinei jėgai</b>,
        "Kalnų slidinėjimas — vienas fiziškai sudėtingiausių sportų pasaulyje. Jis reikalauja, kad širdis, plaučiai ir raumenys veiktų darniai ilgą laiką.",
        <b>Ką rodo Manto DNR:</b>,
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Stiprūs genetiniai žymenys, susiję su VO₂ max potencialu — tai
            reiškia, kad jis efektyviai naudoja deguonį judėjimui
          </CheckmarkItem>
          <CheckmarkItem>
            Palankūs kraujotakos ir kraujagyslių elastingumo genai, palaikantys
            širdies bei plaučių ištvermę
          </CheckmarkItem>
          <CheckmarkItem>
            Pagerintas laktato šalinimas, leidžiantis atsistatyti net fizinio
            krūvio metu
          </CheckmarkItem>
        </div>,
        "Ar tau patinka ilgi bėgimai ar važiavimas dviračiu, bet kankina kvėpavimo ar tempo palaikymo sunkumai?",
        "Tavo ištvermės gebėjimai didžiąja dalimi yra nulemti genetiškai. Vieni natūraliai geriau atlaiko ilgus krūvius, kiti — spindi sprintuose.",
        <b>Tai žinodamas, gali:</b>,
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Treniruotis efektyviau (nešvaistydamas energijos)
          </CheckmarkItem>
          <CheckmarkItem>
            Pasirinkti tau tinkamiausią kardio treniruočių formatą
          </CheckmarkItem>
          <CheckmarkItem>
            Suprasti, ar esi labiau pritaikytas maratonams ar intervalinėms
            treniruotėms
          </CheckmarkItem>
        </div>,
        <img src={blog12_5} />,
        <b>2. Sąnarių sveikata ir traumų prevencija: ištvermės pamatas</b>,
        "Kiekvienas žingsnis ar stūmimas slidėmis apkrauna kelius, klubus ir apatinę nugaros dalį. Būtent ištvermė ir atsparumas, traumoms skiria olimpinius atletus nuo tų, kurie greitai perdega.",
        <b>Ką rodo Manto DNR:</b>,
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Žemesnė nei vidutinė kolageno ir jungiamojo audinio genų raiška
          </CheckmarkItem>
          <CheckmarkItem>
            Nedidelis genetinis polinkis į sąnarių ir sausgyslių perkrovos
            traumas
          </CheckmarkItem>
        </div>,
        "Turint tokius rezultatus galima iš anksto imtis prevencijos — pritaikyti treniruočių krūvius, įtraukti jungiamojo audinio stiprinimo pratimus, parinkti tinkamas maistines medžiagas ir užtikrinti pakankamą atsistatymą.",
        "Tai leidžia ne tik išvengti traumų, bet ir užtikrinti, kad sportinė karjera būtų ilga ir stabili.",
        "Ar po įprastų treniruočių tau skauda sąnarius? Ar dažnai tenka kovoti su pasikartojančiomis sausgyslių problemomis?",
        "Gali būti, kad genetiškai esi labiau linkęs į silpnesnį jungiamąjį audinį — bet tai nereiškia, kad negali sportuoti.",
        <b>Tai reiškia, kad tau reikia:</b>,
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Tikslinių maistinių medžiagų (kolageno, MSM, vitamino C)
          </CheckmarkItem>
          <CheckmarkItem>Geresnės apšilimo ir mobilumo rutinos</CheckmarkItem>
          <CheckmarkItem>
            Ilgalaikės traumų prevencijos mąstysenos
          </CheckmarkItem>
        </div>,
      ],
    },
    {
      id: 5,
      label: "Kas yra biologinis amžius",
      description: [
        <b>Ir kodėl jis svarbesnis už tavo gimtadienį</b>,
        <img src={blog12_6} />,
        "Dauguma žmonių savo amžių vertina pagal skaičių pase. Tačiau mokslas vis aiškiau rodo, kad šis skaičius dažnai menkai pasako apie tikrąją tavo kūno būklę.",
        <span>
          <b>Biologinis amžius</b>— tai rodiklis, parodantis, kiek metų tavo
          kūnas „jaučiasi“ ląstelių lygiu.
        </span>,
        "Jis matuojamas vertinant DNR metilinimo žymes ir kitus molekulinius požymius, kurie atskleidžia, kaip greitai sensta tavo organizmas.",
        "Kartais žmonės būna dešimtmečiu „jaunesni“ už savo pasą, nes jų gyvenimo būdas lėtina senėjimą. Kitais atvejais — kūnas būna „senesnis“ už tikrąjį amžių dėl streso, prastos mitybos ar intensyvaus krūvio be tinkamo atsigavimo.",
        <b>Biologinį amžių lemia:</b>,
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>Stresas ir jo valdymas</CheckmarkItem>
          <CheckmarkItem>Miego kokybė ir trukmė</CheckmarkItem>
          <CheckmarkItem>Fizinė veikla ir atsistatymas</CheckmarkItem>
          <CheckmarkItem>
            Mitybos kokybė ir maistinių medžiagų balansas
          </CheckmarkItem>
          <CheckmarkItem>Uždegiminiai procesai organizme</CheckmarkItem>
          <CheckmarkItem>
            Aplinkos veiksniai (oro tarša, toksinai, klimatas)
          </CheckmarkItem>
        </div>,
        "Kodėl tai svarbu? Nes žinodamas savo biologinį amžių gali objektyviai įvertinti, ar tavo gyvenimo būdas padeda, ar kenkia tavo ilgalaikei sveikatai.",
        "Net ir geriausia genetika negarantuoja ilgos karjeros, jei kūnas nuolat patiria per didelį krūvį ir nespėja atsigauti.",
        "Elitiniai atletai naudoja šiuos duomenis tam, kad pamatytų, ar jų treniruočių strategija padeda išlaikyti jauną biologinį amžių — arba signalizuoja, kad metas keisti taktiką.",
      ],
    },
    {
      id: 6,
      label: "Ką galime iš to pasimokyti?",
      img_src: "",
      description: [
        "Tai – elitiniai atletai, treniruojami geriausių trenerių, mitybos specialistų ir fiziologų. Ir vis dėlto net jie atrado aklų zonų, kai kalba pasisuko apie jų kūno veikimą genetiniu ir biologiniu lygmeniu.",
        "Štai kodėl tai svarbu kiekvienam:",
        <div className="grid grid-cols-2 gap-4">
          <b className="text-center">Įžvalga</b>
          <b className="text-center">Ką tai reiškia tau</b>
          <span>
            Tavo <b>DNR</b> gali atskleisti tavo stiprybes, rizikas ir tau
            tinkamiausią treniruočių stilių.
          </span>
          <div>
            Ar treniruojiesi ištvermei, nors tavo genai labiau pritaikyti jėgai?
            O gal kenti nuo traumų, kurių buvo galima išvengti?
          </div>
          <div>
            Tavo <b>epigenetika </b>atspindi dabartinę kūno būklę.
          </div>
          <div>
            Iš išorės gali atrodyti puikios formos, tačiau viduje gali sparčiai
            didėti uždegimas, nuovargis ar senėjimo procesai.
          </div>
          <div>
            <b>DNR</b> ir <b>epigenetika</b> atskleidžia visą istoriją.
          </div>
          <div>
            Genetika + gyvenimo būdas = rezultatai. Tik pažvelgęs į abu šiuos
            veiksnius gali iš tiesų optimizuoti savo sveikatą ir pajėgumą.
          </div>
        </div>,
      ],
    },
    {
      id: 7,
      label: "Pasiruošęs(-usi) atrasti savo genetinį kodą?",
      description: [
        <img src={blog12_7} />,
        "Sukūrėme trumpą testą, kuris padės mums suprasti tavo gyvenimo būdą, treniruočių įpročius ir tikslus.",
        "Užpildžius testą, gausi asmeninį pasiūlymą, kaip Telomera gali padėti tau:",
        <div className="mt-2 mb-6 flex w-full flex-col gap-[14px]">
          <CheckmarkItem>
            Atskleisti savo biologinius ir genetinius pranašumus
          </CheckmarkItem>
          <CheckmarkItem>
            Susikurti treniruočių ir atsistatymo strategiją, pritaikytą tavo
            kūnui
          </CheckmarkItem>
          <CheckmarkItem>
            Sulėtinti senėjimą ir išvengti lėtinio uždegimo
          </CheckmarkItem>
        </div>,
      ],
    },
    {
      id: 8,
      labelClass: "text-center",
      label: "Užpildyk 5 minučių testą dabar",
      description: [
        <a
          href={`https://telomera.typeform.com/to/${
            import.meta.env.VITE_TYPEFORM_ADVERTORIAL
          }`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ position: "relative", paddingRight: "48px" }}
          className="group bg-dark mx-auto flex w-min cursor-pointer items-center gap-[10px] rounded-[40px] p-2 pr-[40px] hover:enabled:brightness-95 md:gap-[14px]"
        >
          <span
            style={{ lineHeight: "40px" }}
            className="w-full flex-nowrap px-4 font-medium whitespace-nowrap text-white md:text-lg"
          >
            Pradėti testą
          </span>
          <div
            style={{
              position: "absolute",
              right: "8px",
              transition: "all 0.3s",
            }}
            className="bg-dark flex h-[40px] w-[40px] items-center justify-center rounded-full group-hover:w-[calc(100%-16px)]"
          >
            <ArrowRight width={24} height={24} color={"var(--color-primary)"} />
          </div>
        </a>,
      ],
    },
  ],
};

const ADVERTORIAL_TO_CONSULT_WITHOUT_SLUG: BlogContent = {
  ...ADVERTORIAL_TO_TEST_WITHOUT_SLUG,
  id: 13,
  advertorialData: {
    header: "Užsiregistruok 15min. konsultacijai",
    button: (
      <ActionLink
        to={ROUTES.CONSULTATION}
        variant="dark"
        className="hidden w-full md:flex md:w-auto"
      >
        Registruotis
      </ActionLink>
    ),
  },
  innerData: ADVERTORIAL_TO_TEST_WITHOUT_SLUG.innerData!.map((x) => {
    if (x.id !== 8) return x;
    return {
      id: 8,
      labelClass: "text-center",
      label: "Registruokis 15min konsultacijai",
      description: [
        <ActionLink
          to={ROUTES.CONSULTATION}
          variant="dark"
          className="hidden w-full md:flex md:w-auto"
        >
          Registruotis
        </ActionLink>,
      ],
    };
  }),
};

export const ADVERTORIAL_TO_TEST: BlogContentWithSlug = addSlug(
  ADVERTORIAL_TO_TEST_WITHOUT_SLUG,
);
export const ADVERTORIAL_TO_CONSULT: BlogContentWithSlug = addSlug(
  ADVERTORIAL_TO_CONSULT_WITHOUT_SLUG,
);
